export default "__VITE_ASSET__CHWWDklS__"